<template>
  <div class="about">
    <h2>Knowledge base</h2>

    <div class="loading" v-if="loading">
        Loading...
    </div>
    <div v-if="error" class="error">
      {{ error }}
    </div>
    <h4>Processes <router-link to="/kb/process/new" class="btn btn-primary">New process</router-link></h4>
    <div v-if="processes" class="content">
        <b-table striped :items="processes" :fields="fields">
            <template slot="actions" slot-scope="data">
                <b-btn :to="'/kb/1/process/' + data.item.knowledge_process_id + '/detail'" variant="secondary" size="sm">Details</b-btn>
                <b-btn @click="show_edit_modal(data.item)" variant="primary" size="sm" style="margin-left: 10px">Edit</b-btn>
            </template>
            <template slot="created" slot-scope="data">
                {{ data.item.created_at | moment("YYYY-MM-DD hh:ss") }}
            </template>
        </b-table>
    </div>

    <b-modal ref="processEditModal" :title="'Edit Process (id: ' + knowledge_process_form.knowledge_process_id + ')'" @ok="save_knowledge_process" size="lg" ok-title="Save">
        <b-form @submit.prevent="save_knowledge_process">
            <KnowledgeProcessForm :form="knowledge_process_form"></KnowledgeProcessForm>
        </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import KnowledgeProcessDetails from '@/components/KnowledgeProcessDetails.vue'
import KnowledgeItemForm from '@/components/KnowledgeItemForm.vue'
import KnowledgeProcessForm from '@/components/KnowledgeProcessForm.vue'

export default {
  data () {
    return {
        loading: false,
        post: null,
        knowledge_process: {},
        knowledge_items: [],
        new_item: {
            group: '',
            title: '',
            description: ''
        },
        edit_item: {
            group: '',
            title: '',
            description: '',
            knowledge_item_id: -1
        },
        knowledge_process_form: {
            name: '',
            description: '',
            knowledge_process_id: -1
        },
        processes: [],
        fields: [
            {
                key: 'knowledge_process_id',
                label: 'Id'
            },
            {
                key: 'name',
                label: 'Name'
            },
            {
                key: 'created',
                label: 'Created'
            },
            {
                key: 'count_items',
                label: '# Risks'
            },
            {
                key: 'actions',
                label: ' '
            }
        ]
    }
  },
  components: {
      KnowledgeProcessDetails,
      KnowledgeItemForm,
      KnowledgeProcessForm
  },
  created () {
      this.fetchData()
  },
  watch: {
      '$route': 'fetchData'
  },
  methods: {
      handleOk() {
          this.$http.put('v1/kb/1/processes/' + this.$route.params.knowledge_process_id + '/items/' + this.edit_item.knowledge_item_id, this.edit_item).then(response => {
              this.fetchData()
          });
      },
      fetchData() {
          this.error = this.post = null;
          this.loading = true;
          this.$http.get('v1/kb/1/processes').then(response => {
              this.processes = response.data.response;
              this.loading = false;
          });
      },
      new_knowledge_item_submit() {
          this.$http.post('v1/kb/1/processes/' + this.$route.params.knowledge_process_id + '/items', this.new_item).then(response => {
              this.knowledge_items.push(response.data.response);
              this.reset_new_knowledge_base_form();
          });
      },
      reset_new_knowledge_base_form() {
          this.new_item.group = '';
          this.new_item.title = '';
          this.new_item.description = '';
      },
      edit_knowledge_item_submit() {
          console.log("jslkfjdslf");
      },
      toggle_edit(item) {
          this.$refs.editModal.show();
          this.edit_item.group = item.group;
          this.edit_item.title = item.title;
          this.edit_item.description = item.description;
          this.edit_item.knowledge_item_id = item.knowledge_item_id;
      },
      show_edit_modal(process) {
          console.log("->", process)
          this.knowledge_process_form.name = process.name;
          this.knowledge_process_form.description = process.description;
          this.knowledge_process_form.knowledge_process_id = process.knowledge_process_id;
          this.$refs.processEditModal.show();
      },
      save_knowledge_process() {
          this.$http.put('v1/kb/1/processes/' + this.knowledge_process_form.knowledge_process_id, this.knowledge_process_form).then(response => {
              this.fetchData();
              this.$refs.processEditModal.hide();
      })
    }
  }
}
</script>
<style scoped>
small {
    color: gray;
}
.description {
  white-space: pre-wrap; 
  word-wrap: break-word;
  font-family: inherit;
}
.edit-btn {
    position: absolute;
    right: 10px;
    bottom: 10px;
}
</style>
